module.exports = __webpack_public_path__ + "static/media/work-banner.6f9d37c8.png";